/* The homepage's outbound section register, and the nine buttons that link to
   it. v7.

   WHAT CHANGED FROM v6. The ROI section has moved out. Its key, the opening
   words of its heading, is now in MOVED pointing at /pages/roi, and the band
   below has a ninth button. The heading counts to match: nine, not eight.

   That section was the second largest block on the page at 1,910px, and every
   figure in it - 39x, 23x, the guarantee targets, the attribution table - now
   sits on a page a visitor chooses to open rather than scrolls through.

   WHY THE KEY IS A PHRASE AND NOT AN ID. That section carries no id: it is
   <section class="sec" style="padding-top:8px">. findSection falls back to the
   opening words of an h2 or h3, and 'Your ROI, guaranteed' is unique on the
   page. If the heading is ever reworded the key stops matching, the section
   reappears on the homepage, and nothing else breaks - which is the failure
   mode this register was built to have.

   WHAT CHANGED IN v6. The Compliance section stopped being hidden: its panel is
   wanted on the homepage, so 'enterprise' came out of MOVED. The same markup is
   also on /pages/compliance and neither copy knows about the other; edit both.

   WHAT CHANGED IN v5. Playbooks and Rockkt One got pages, taking the band from
   six buttons to eight.

   Rockkt One is NOT in MOVED and must not be, because it was never a section.
   It was the split hero, rendered by layout/rockkt.liquid into a hidden dock and
   moved at run time; the layout now simply does not render it on the homepage.
   If it ever goes back, the render and the hero-split css/js go back in the
   layout - not a key here.

   /pages/send-playbooks, not /pages/playbooks: that handle already belongs to
   the guides hub ("Playbooks: direct mail that earns a reply"), which is
   content, not the product.

   WHAT DID NOT CHANGE, AND MUST NOT. MOVED below is still the register that
   SHORTENS the homepage. For every key in it the matching section is set to
   display:none. If you edit this file, the hide loop is the load-bearing part;
   the buttons are just presentation.

   templates/index.liquid is 236KB and past what the Admin API will replace as
   text, which is why the sections are hidden at run time from here rather than
   being deleted from the template. They should eventually be deleted by hand in
   the theme editor - until then that content is live at two URLs.

   THE BAND IS NOT THE NAV. The header Features menu and the footer Features
   column still list eight pages, not nine: ROI was added here only. If it
   should be a ninth feature everywhere, that is rockkt-nav-features-v3.js and
   rockkt-footer-sync-v4.js, and all three lists move together.

   COPY. No statistic appears in this file. Several figures on the page around it
   are still flagged as unsourced and this site's editorial policy forbids
   publishing one without a source. */
(function () {

  /* Sections that now live on their own page.
     Key resolves to a homepage section by id, or by the opening words of its
     first h2/h3. Value is where that section went. Two keys can share a
     destination: Tracking and Intent alerts are one page, Gift Lab and Home or
     office are another. Adding the next move is one line here. */
  var MOVED = {
    'flight-deck':          '/pages/flight-deck',
    'design-studio':        '/pages/design-studio',
    'Every prospect':       '/pages/navigator',
    'Watch every':          '/pages/tracking',
    'intent':               '/pages/tracking',
    'Any gift':             '/pages/gift-lab',
    'hybrid':               '/pages/gift-lab',
    'Prewrite the perfect': '/pages/send-playbooks',
    'Your ROI, guaranteed': '/pages/roi'
  };

  /* The nine buttons: href, sprite symbol, label, one line.
     Ordered the way the product is used: where you work, what you save, what
     you send, how it looks, where it lands, what you see, what you do next,
     what it was worth, and what keeps you out of trouble. */
  var BUTTONS = [
    ['/pages/rockkt-one',     'g-click',        'Rockkt One',    'Send from any LinkedIn profile, without leaving it'],
    ['/pages/send-playbooks', 'g-list',         'Playbooks',     'Prewrite the send, fire it in twenty seconds'],
    ['/pages/gift-lab',       'g-gift',         'Gift Lab',      'Any gift, packed, boxed and posted'],
    ['/pages/design-studio',  'g-sparkles',     'Design Studio', 'Your brand, down to the box on the desk'],
    ['/pages/flight-deck',    'g-rocket',       'Flight Deck',   'Personalised landing pages, built in minutes'],
    ['/pages/tracking',       'g-chart',        'Tracking',      'Every send and every signal, in real time'],
    ['/pages/navigator',      'g-compass',      'Navigator',     'Prospects, sequences and next steps'],
    ['/pages/roi',            'g-trending-up',  'ROI',           'Pipeline, closed-won and the guarantee, tracked live'],
    ['/pages/compliance',     'g-shield-check', 'Compliance',    'Caps, approvals and a full audit trail']
  ];

  /* Resolve a key to a section: an id first, then the opening words of an h2 or
     h3. Returns null when nothing matches, and that key is simply skipped - a
     section that is renamed or deleted costs nothing here. */
  function findSection(key) {
    var byId = document.getElementById(key);
    if (byId && byId.tagName === 'SECTION') return byId;
    var secs = document.querySelectorAll('section');
    for (var i = 0; i < secs.length; i++) {
      var h = secs[i].querySelector('h2, h3');
      if (h && h.textContent.replace(/\s+/g, ' ').trim().indexOf(key) === 0) return secs[i];
    }
    return null;
  }

  /* Hide every moved section. This is the part that shortens the page. */
  function hideMoved() {
    var n = 0;
    for (var key in MOVED) {
      if (!Object.prototype.hasOwnProperty.call(MOVED, key)) continue;
      var sec = findSection(key);
      if (sec) { sec.style.display = 'none'; n++; }
    }
    return n;
  }

  /* Where the band goes: immediately before the closing call to action, so it is
     the last thing read before the ask rather than after it. Each fallback is one
     step further out, and the last of them cannot fail. */
  function anchorNode() {
    return document.getElementById('cta')
        || document.querySelector('section.final')
        || document.querySelector('.rk-ask')
        || document.querySelector('footer');
  }

  function build() {
    hideMoved();

    if (document.querySelector('.rkx6')) return;          /* already built */

    var anchor = anchorNode();
    if (!anchor || !anchor.parentNode) return;

    var tiles = BUTTONS.map(function (b) {
      return '<a class="rkx6-btn" href="' + b[0] + '">' +
               '<span class="rkx6-ic"><svg class="icn" aria-hidden="true"><use href="#' + b[1] + '"/></svg></span>' +
               '<span class="rkx6-txt"><b>' + b[2] + '</b><span>' + b[3] + '</span></span>' +
               '<span class="rkx6-go" aria-hidden="true">' +
                 '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
                 'stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h13"/><path d="M13 6l6 6-6 6"/></svg>' +
               '</span>' +
             '</a>';
    }).join('');

    var sec = document.createElement('section');
    sec.className = 'rkx6';
    sec.setAttribute('aria-labelledby', 'rkx6Title');
    sec.innerHTML =
      '<div class="wrap">' +
        '<div class="rkx6-inner">' +
          '<div class="rkx6-head">' +
            '<span class="rkx6-eyebrow">Go deeper</span>' +
            '<h2 id="rkx6Title">Nine places to look next</h2>' +
            '<p>Each one is a page of its own, with the whole thing laid out properly.</p>' +
          '</div>' +
          '<nav class="rkx6-grid" aria-label="More about Rockkt">' + tiles + '</nav>' +
        '</div>' +
      '</div>';

    anchor.parentNode.insertBefore(sec, anchor);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
